/**
 * Maps emoji unicode characters to their filename in the website files S3 bucket.
 * The images are used for consistent cross-platform rendering. The images are
 * from the Google Noto Emoji font, and are downloaded from Slack.
 * @see https://archipro.atlassian.net/wiki/spaces/AD/pages/1775566849/Website+files
 * @see https://fonts.google.com/noto/specimen/Noto+Emoji
 * @see https://a.slack-edge.com/production-standard-emoji-assets/14.0/google-large/1f44d.png
 */
const EMOJI_FILENAME_MAP: Readonly<Record<string, string>> = {
    '👍': '1f44d',
    '❤️': '2764-fe0f',
    '😂': '1f602',
    '😢': '1f622',
    '🔥': '1f525',
    '🎉': '1f389',
    '👀': '1f440',
};

/**
 * Ordered list of emoji characters available for chat reactions.
 * @see {@link /app/_config/chat-reactions.yml}
 */
export const AVAILABLE_REACTIONS = [
    '👍',
    '❤️',
    '😂',
    '😢',
    '🔥',
    '🎉',
    '👀',
] as const;

export function getEmojiImageUrl(emoji: string) {
    const filename = EMOJI_FILENAME_MAP[emoji];
    if (!filename) {
        return undefined;
    }
    return `/assets/website/ui/emoji/32/${filename}.png`;
}
